import { StyleRules, TablePaginationClassKey } from "@material-ui/core";
import { PrimaryColors } from "../../../style/Colors";

export const MuiTablePagination: Partial<StyleRules<TablePaginationClassKey, {}>> = {
  root: {
    backgroundColor: PrimaryColors.base,
    color: "inherit",
  },
};
